// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rich-text-editor-toolbar{background:#f7f7f7;color:#222;margin-bottom:0}.rich-text-editor-toolbar *::-webkit-scrollbar{width:.5em;background-color:#eee}.rich-text-editor-toolbar *::-webkit-scrollbar-track{-webkit-box-shadow:none;background-color:#eee}.rdw-option-wrapper{border:none}.rdw-colorpicker-modal{width:210px}.rich-text-editor{padding:0 1em;min-height:10em}.rich-text-editor .rdw-image-alignment-options-popup{color:#222;display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
